export default class extends Controller {
  static targets = ["timeField", "allDayCheckbox"];

  connect() {
    this.toggleTimeFields();
  }

  toggleTimeFields() {
    this.showTimeFields = !this.allDay;
  }

  //
  // GETTERS AND SETTERS
  //

  get allDay() {
    return !!this.allDayCheckboxTarget.checked;
  }

  set showTimeFields(val) {
    this.timeFieldTargets.forEach(timeField => App.Helpers[`${val ? "show" : "hide"}Element`](timeField));
  }
};



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-date-time-fields-controller.js